import React from "react";
import { SchedulerQualityControl } from "../scheduler-quality-control-page.jsx";

export default function SchedulingQualityControlTab({ guid }) {
  return <SchedulerQualityControl channelGuid={guid} />;
}
